<template>
<main class="row onboarding-wrapper">
    <div class="col-md-12 ob-rightcol" v-if="!loading">
        <div class="primary-heading" >
            Add a payment method to complete your profile.
        </div>
        <div class="secondary-heading">
            Adding a credit card to your profile will expedite the checkout process when you want some brochures in a hot minute. Or skip this step and we can prompt you when needed.
        </div>
        <div class="state-agent w800 mt-4" >
			<AddCard @setCookieAndLogin="setCookieAndLogin"/>
        </div>
    </div>
    <div class="loader-spinner"  v-if="loading"></div>
</main>
</template>


<script>
// @ is an alias to /src
import AddCard from '../views/AddCard.vue'
import {appEnv, worbixServerUrl} from '@/properties'
export default {
    name: 'State',
    components: {
        AddCard
    },
    data(){
        return{
            card:{},
            cardName:"",
            loading:false,
            clientSecret:{},
            stripe:{},
        }
    },
    mounted() {
        this.personId = this.$route.params.personId
        if(!this.agent) {
            this.getBasicProfile();
        }
    },
    methods:{
        showError(errorMsgText) {
            this.changeLoadingState(false);
            var errorMsg = document.querySelector(".sr-field-error");
            errorMsg.textContent = errorMsgText;
            setTimeout(function() {
                errorMsg.textContent = "";
            }, 4000);
        },
        getBasicProfile(){
            let payload = {
                personId : this.personId,
            }
            this.loading = true;
            this.$store.dispatch("getBasicProfile", payload).then((res) => {
                this.loading = false;
            })
        },
        async setCookieAndLogin(){
            let payload = {}
            payload.cookieString = `siteId=${this.getCookie('siteId')}&spaceId=${this.getCookie('spaceId')}&actorId=${this.getCookie('actorId')}&userId=${this.getCookie('userId')}&accessToken=${this.getCookie('tokenKey')}&currentUser=${this.getCookie('currentUser')}&requestUrlEncoded=${worbixServerUrl.split('/')[2]}`;
            payload.siteDomain = this.getCookie('siteDomain') ? this.getCookie('siteDomain') : null;

            let setDomainCookie = await this.$store.dispatch("setDomainCookie", payload);
            setTimeout(()=>{
                window.location.href = worbixServerUrl;
            }, 2000)
        },
        getCookie(cname){
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for(var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        orderComplete(clientSecret) {
            let vm = this;
            this.stripe.retrievePaymentIntent(clientSecret).then(function(result) {
                var paymentIntent = result.paymentIntent;
                var paymentIntentJson = JSON.stringify(paymentIntent, null, 2);

                document.querySelector(".sr-payment-form").classList.add("hidden");
                document.querySelector("pre").textContent = paymentIntentJson;

                document.querySelector(".sr-result").classList.remove("hidden");
                setTimeout(function() {
                    document.querySelector(".sr-result").classList.add("expand");
                }, 200);

                vm.changeLoadingState(false);
            });
        },
        changeLoadingState(isLoading) {
            if (isLoading) {
                document.querySelector("button").disabled = true;
                document.querySelector("#spinner").classList.remove("hidden");
                document.querySelector("#button-text").classList.add("hidden");
            } else {
                document.querySelector("button").disabled = false;
                document.querySelector("#spinner").classList.add("hidden");
                document.querySelector("#button-text").classList.remove("hidden");
            }
        }
    }
}
</script>

<style>
	input,
	.StripeElement {
	  height: 48px;
	  color: #32325d;
	  background-color: white;
	  border: 1px solid transparent;
	  border-radius: 4px;
	  box-shadow: 0 1px 3px 0 #e6ebf1;
	  -webkit-transition: box-shadow 150ms ease;
	  transition: box-shadow 150ms ease;
	}

	input {
	  padding: 10px 12px;
	}


	.StripeElement--invalid {
	  border-color: #fa755a;
	}

	.StripeElement--webkit-autofill {
	  background-color: #fefde5 !important;
	}

	.button-style{
		display: flex;
		justify-content: flex-end;
	}

	.__PrivateStripeElement{
		height:98px !important
	}

	iframe {
    	height: 98px !important;
	}

	.ElementsApp {
    	height: 98px !important;
	}

	.CardField-input-wrapper.is-ready-to-slide {
    	height: 100% !important;
	}

	span.CardField-number.CardField-child {
    	height: 100% !important;
	}
	span.CardField-number-fakeNumber {
    	height: 100% !important;
	}
	.CardNumberField.CardNumberField--ltr {
    	height: 100% !important;
	}
	.CardNumberField-input-wrapper {
    	height: 100% !important;
	}
	span.InputContainer {
    	height: 100% !important;
	}
	input.InputElement.is-invalid.Input {
    	height: 100% !important;
		font-size: 45px;
	}
	.headline{
		font-size: 20px;
		font-weight: bold;
		text-align: center
	}
</style>
